import React, { useState, useEffect, useMemo } from 'react';
import { GridTableProductRow } from './OnlineMarketsGridViewTableProductRow';

const getMaxGlowTime = (contracts) => {
    let maxGlowTime = 0;
    (contracts || []).forEach((row, idx) => {
        if (idx === 0) {
            return;
        }
        
        const { created_seconds_ago, updated_seconds_ago } = row;
        const glowTime = typeof updated_seconds_ago === 'number' 
            ? (300 - updated_seconds_ago) 
            : (300 - created_seconds_ago);            
        maxGlowTime = glowTime > maxGlowTime ? glowTime : maxGlowTime;            
    });

    return maxGlowTime;
};

const GridTableProductPeriod = (props) => {
    const { data, productName, placeOrder, getOrder, callDH, showOrderPopup, product, user } = props;
    const  { BUY, SELL, period } = data;

    const long = BUY.length > SELL.length ? BUY : SELL;
    const [showAll, setShowAll] = useState(false);
    const [isExpandGlowing, setIsExpandGlowing] = useState(false);
   
    const formatted = useMemo(() => {
        if (showAll && long.length < 2) {
            setShowAll(false);
        }
        return long.map((item, index) => ({BUY: BUY[index], SELL: SELL[index]}));
    }, [BUY, SELL, long]) 

    const canExpand = long.length > 1;
    const toggleExpand = () => {
        if (!canExpand) return;
        setShowAll(!showAll)
    };

    useEffect(() => {
        const bidsMaxGlowTime = getMaxGlowTime(BUY);
        const offersMaxGlowTime = getMaxGlowTime(SELL);
        let timer = null;

        const maxGlowTime = bidsMaxGlowTime > offersMaxGlowTime ? bidsMaxGlowTime : offersMaxGlowTime;

        setIsExpandGlowing(maxGlowTime > 0);
        
        if (maxGlowTime > 0) {
            timer = setTimeout(() => setIsExpandGlowing(false), 1000 * maxGlowTime);
        }

        return () => {
            if (timer) clearTimeout(timer);
        };
    }, [BUY, SELL]);

    return (
        <div style={showAll ? {paddingBottom:'12px'} : {paddingBottom:'0px'}}>{
            formatted.map( (contracts, contractIndex) => {
                if (!showAll && contractIndex !== 0) return null;

                return (
                    <GridTableProductRow 
                        key={`${productName}_${period}_${contractIndex}`} 
                        product={product}
                        user={user}
                        period={period}
                        bid={contracts.BUY}
                        offer={contracts.SELL}
                        placeOrder={placeOrder}
                        callDH={callDH}
                        getOrder={getOrder}
                        toggleExpand={toggleExpand}
                        expanded={showAll}
                        canExpand={contractIndex === 0 && canExpand}
                        showOrderPopup={showOrderPopup}
                        isExpandGlowing={contractIndex === 0 && !showAll && isExpandGlowing}
                        onMouseOver={props.onMouseOver}
                        onMouseOut={props.onMouseOut}
                    />
        )})
    }
    {long.length === 0 &&  (
    <   GridTableProductRow 
            key={`${productName}_${period}_0`} 
            product={product}
            user={user}
            period={period}
            activity={undefined}
            placeOrder={placeOrder}
            toggleExpand={toggleExpand}
            expanded={showAll}
            canExpand={false}
            showOrderPopup={showOrderPopup}
            isExpandGlowing={false}

        />
    )}
    </div>
    )
}
export {GridTableProductPeriod}


// WEBPACK FOOTER //
// ./source/components/OnlineMarketsGridViewTableProductPeriod.js